export enum IdentityValidationStageName {
  PRISTINE = 'PRISTINE',
  INITIALIZED = 'INITIALIZED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  REJECTED_WITH_RETRY_OPTION = 'REJECTED_WITH_RETRY_OPTION',
  REVIEW_PENDING = 'REVIEW_PENDING',
}

export const getIdentityValidationStageName = (name: string) => {
  const values = Object.values(IdentityValidationStageName);
  const found = values.find((value) => value === name);
  if (found) {
    return found;
  }
  throw Error('Unsuported identity validation stage name');
};
